/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FamiliesSavingsScreensRequest} from '@cash-web/protos/squareup/cash/app/families_savings_screens.pb'
import {FamiliesSavingsScreensResponse} from '@cash-web/protos/squareup/cash/app/families_savings_screens.pb'


export const familiesSavingsScreens = (request: FamiliesSavingsScreensRequest, options?: CashRequestOptions) => post<FamiliesSavingsScreensRequest, FamiliesSavingsScreensResponse>("/2.0/cash/families-savings-screens", request, {...options, rejectOnError: true })